import EventListener from "@/mixins/EventListener.mixin";
import { NumericPickerComponent } from "helix-vue-components";
import cloneDeep from "lodash/cloneDeep";
import { Component, Mixins, Prop } from "vue-property-decorator";
import Template from "./UsersSeatsManagerModal.template.vue";

@Component({
  mixins: [Template],
  components: {
    "numeric-picker": NumericPickerComponent
  }
})
export default class UsersSeatsManagerModal extends Mixins(EventListener) {
  @Prop({ default: 5 }) public usersSeats!: number;
  public seats: number = 0;
  @Prop({ default: 0 })
  public min!: number;
  @Prop({ default: 0 }) public costPerUnit!: string;

  public get diff(): number {
    return Math.abs(this.usersSeats - this.seats);
  }

  public get action() {
    return this.usersSeats - this.seats < 0
      ? this.$t("adding")
      : this.$t("removing");
  }

  public get edited(): boolean {
    return this.usersSeats !== this.seats;
  }

  public get upgraded(): boolean {
    return this.seats > this.usersSeats;
  }

  public get downgraded(): boolean {
    return this.seats < this.usersSeats;
  }

  public get totalCost() {
    return this.diff * +this.costPerUnit;
  }

  protected mounted() {
    this.seats = cloneDeep(this.usersSeats);
    this.keyUp("Esc", () => {
      this.close();
    });
    this.keyUp("Enter", () => {
      if (+this.seats > +this.min) {
        this.save();
      }
    });
  }

  protected close() {
    this.$emit("reject");
  }

  protected save() {
    this.$emit("resolve", {
      users: this.seats
    });
  }
}
